import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 Stemphor Techlabs LLP.</p> 
      <p>All rights reserved.</p>
    </footer>
  );
};

export default Footer;
